import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useAuth } from "../../context/AuthContext";

const DescargarApp = () => {
  const history = useHistory();
  const { isAuthenticated, loginWithRedirect } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleButtonClick = () => {
    if (isAuthenticated) {
      history.push("/eventos");
    } else {
      loginWithRedirect({
        appState: { returnTo: "/eventos" }
      });
    }
  };

  return (
    <div
      className="d-flex flex-column align-items-center"
      style={{
        marginTop: "0",
        marginLeft: isMobile ? "0" : "12%",
        marginRight: isMobile ? "0" : "12%",
        marginBottom: "5%",
        textAlign: "center"
      }}
    >
      {/* Imagen principal de la sección */}
      <img
        src="/passgo-hd.jpg"
        alt="App Pass"
        style={{
          marginBottom: "50px",
          borderRadius: isMobile ? "0" : "10px",
          maxWidth: "100%",
          height: isMobile ? "250px" : "420px",
          width: "100%"
        }}
      />

      {/* Título */}
      <div style={{ margin: isMobile ? "0 12%" : 0 }}>

        <p style={{ fontSize: isMobile ? "32px" : "44px", fontWeight: "bold", lineHeight: "34px", color: "#5656ff", marginBottom: "15px" }}>
          Controlá el acceso a tu evento
        </p>

        <p style={{ color: "#0B0062", fontSize: "18px", marginBottom: "25px" }}>
          Descargá la app y escaneá entradas ¡en segundos! <br />
          Simple, rápido y desde tu celular.
        </p>
      </div>
      <div className="d-flex flex-column gap-1 mb-4">
        <a
          href="https://play.google.com/store/apps/details?id=ar.com.passgo"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            alt="Disponible en Google Play"
            src="https://play.google.com/intl/es-419/badges/static/images/badges/es-419_badge_web_generic.png"
            style={{ height: "65px", width: "100%" }}
          />
        </a>

        <button
          onClick={() => setShowModal(true)}
          style={{
            display: "inline-block",
            padding: "8px 20px",
            backgroundColor: "transparent",
            color: "#5656ff",
            borderRadius: "8px",
            fontWeight: "bold",
            fontSize: "16px",
            border: "none",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          Ver tutorial de uso
        </button>
      </div>

      {/* Modal de video estilo celular */}
      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          style={{
            position: "fixed",
            top: 20,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            padding: "20px",
            boxSizing: "border-box",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "360px",        // ancho tipo celular
              maxWidth: "100%",      // responsive
              borderRadius: "12px",
              overflow: "hidden",
              backgroundColor: "black",
              boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
            }}
          >
            <video
              src="/app.mp4"
              controls
              autoPlay
              style={{
                width: "100%",
                height: "auto",
                display: "block",
              }}
            />
            {/* Botón cerrar */}
            <button
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                backgroundColor: "rgba(0,0,0,0.5)",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
              &times;
            </button>
          </div>
        </div>
      )}


    </div>
  );
};

export default DescargarApp;
